module.exports = __webpack_public_path__ + "static/media/title.b5a25194.png";